export default __webpack_public_path__ + "static/media/redYoutubeIcon.66c7f5b1.png";